import { render, staticRenderFns } from "./Investing.vue?vue&type=template&id=2e679540&scoped=true&"
import script from "./Investing.vue?vue&type=script&lang=js&"
export * from "./Investing.vue?vue&type=script&lang=js&"
import style0 from "./Investing.vue?vue&type=style&index=0&id=2e679540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e679540",
  null
  
)

export default component.exports